import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import { assetUrl } from "api/client";

/** Icon lấy từ assets của game (vật phẩm, pet, danh hiệu...). Không có ảnh thì hiện icon dự phòng. */
function GameIcon({ path, size, fallback }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [path]);

  if (!path || failed) {
    return (
      <MDBox
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        width={size}
        height={size}
        color="text"
      >
        <Icon sx={{ fontSize: `${Math.round(size * 0.8)}px !important` }}>{fallback}</Icon>
      </MDBox>
    );
  }
  return (
    <MDBox
      component="img"
      src={assetUrl(path)}
      alt=""
      onError={() => setFailed(true)}
      flexShrink={0}
      sx={{ width: size, height: size, objectFit: "contain", imageRendering: "pixelated" }}
    />
  );
}

GameIcon.defaultProps = {
  path: null,
  size: 24,
  fallback: "category",
};

GameIcon.propTypes = {
  path: PropTypes.string,
  size: PropTypes.number,
  fallback: PropTypes.string,
};

export default GameIcon;
